import React, { useEffect, useState } from 'react';

import { IonButton, IonItem } from '@ionic/react';

import Typography from 'components/Typography';

import Logo from '../Logo';
import { oktaAuth } from '../okta';

const CallbackPage: React.FC = () => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // oktaAuth;
    if (oktaAuth?.isLoginRedirect?.()) {
      oktaAuth.handleRedirect().then(
        () => {
          window.location.replace('/');
        },
        (err: Error) => {
          console.log('catch', err);
          setError(
            err.message ||
              'An error occurred while logging in. Please try again.'
          );
        }
      );
    }
  }, [oktaAuth]);

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          height: '100vh',
        }}
      >
        <div
          style={{
            height: '120px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Logo />
        </div>

        {error ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              padding: '0 16px',
            }}
          >
            <Typography variant={'body2'} color={'danger'}>
              {error}
            </Typography>
            <IonButton
              routerLink={'/login'}
              routerDirection={'forward'}
              style={{ marginTop: '16px' }}
            >
              Back to login
            </IonButton>
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography variant={'subtitle1'}>Processing login...</Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export default CallbackPage;
